import GET_VIDEOS_BY_DEVICE_ID from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/posting/getVideosByDeviceId.graphql';
import { useQueryWithBoundary } from 'src/hooks';
import { normalizeVideo, normalizePageInfo } from './useGetVideosByLocationId';

export const useGetVideosByDeviceId = (deviceId: string | null) => {
  const { data, ...rest } = useQueryWithBoundary(GET_VIDEOS_BY_DEVICE_ID, {
    // 10 minutes interval
    pollInterval: 600000,
    variables: {
      device_id: deviceId,
    },
    skip: deviceId === 'all-cameras' || deviceId === null,
  });

  if (data) {
    return {
      ...rest,
      data: {
        videos: data.ringVideosByDeviceId?.edges.map(normalizeVideo),
        ...normalizePageInfo(data.ringVideosByDeviceId?.pageInfo),
      },
    };
  }

  return {
    ...rest,
    data: {
      videos: [],
      hasNextPage: false,
      endCursor: null,
    },
  };
};
